import React, { useContext } from "react";
import AppContext from "../contexts/AppContext";

import Box from "@material-ui/core/Box";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import { makeStyles } from "@material-ui/core/styles";

import componentStyles from "../assets/styles/components/sidebar";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(componentStyles);

const IssueFilter = (props) => {
  const { state } = useContext(AppContext);
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h6" component="h6" classes={{ root: classes.title }}>
        {t("issu_filter.label_filter")}
      </Typography>

      <FormGroup classes={{ root: classes.filterFormGroup }}>
        <FormLabel classes={{ root: classes.formLabel }}>
          {t("field_status")}
        </FormLabel>
        <FormControl variant="filled" component={Box} width="100%">
          <Box paddingLeft="1.5rem" paddingRight="1.5rem">
            <Select
              id="issue-filter-status"
              value={
                state.current.issueFilter
                  ? state.current.issueFilter.status_id
                  : ""
              }
              onChange={props.handleChangeStatusfunc}
              displayEmpty
            >
              <MenuItem value="">
                <em>{t("label_open_issues")}</em>
              </MenuItem>
              <MenuItem value="*">
                <em>{t("label_all")}</em>
              </MenuItem>
              {state.current.issueStatuses
                ? state.current.issueStatuses.map((status, index) => {
                    return (
                      <MenuItem key={index} value={status.id}>
                        {status.name}
                      </MenuItem>
                    );
                  })
                : ""}
            </Select>
          </Box>
        </FormControl>
      </FormGroup>

      <FormGroup classes={{ root: classes.filterFormGroup }}>
        <FormLabel classes={{ root: classes.formLabel }}>
          {t("field_author")}
        </FormLabel>
        <FormControl variant="filled" component={Box} width="100%">
          <Box paddingLeft="1.5rem" paddingRight="1.5rem">
            <Select
              id="issue-filter-author"
              value={
                state.current.issueFilter
                  ? state.current.issueFilter.author_id
                  : ""
              }
              onChange={props.handleChangeAuthorfunc}
              displayEmpty
            >
              <MenuItem value="">
                <em>{t("label_all")}</em>
              </MenuItem>
              {state.current.projectMembers &&
              state.current.projectMembers.length ? (
                state.current.projectMembers.map((member, index) => {
                  const user = member.user;
                  return (
                    <MenuItem key={index} value={user.id}>
                      {user.name}
                    </MenuItem>
                  );
                })
              ) : state.current.user ? (
                <MenuItem
                  value={state.current.user.id}
                >{`${state.current.user.lastname} ${state.current.user.firstname}`}</MenuItem>
              ) : (
                ""
              )}
            </Select>
          </Box>
        </FormControl>
      </FormGroup>

      <FormGroup classes={{ root: classes.filterFormGroup }}>
        <FormLabel classes={{ root: classes.formLabel }}>
          {t("field_assigned_to")}
        </FormLabel>
        <FormControl variant="filled" component={Box} width="100%">
          <Box paddingLeft="1.5rem" paddingRight="1.5rem">
            <Select
              id="issue-filter-assigned-to"
              value={
                state.current.issueFilter
                  ? state.current.issueFilter.assigned_to
                  : ""
              }
              onChange={props.handleChangeAssignedTofunc}
              displayEmpty
            >
              <MenuItem value="">
                <em>{t("label_all")}</em>
              </MenuItem>
              {state.current.projectMembers &&
              state.current.projectMembers.length ? (
                state.current.projectMembers.map((member, index) => {
                  const user = member.user;
                  return (
                    <MenuItem key={index} value={user.id}>
                      {user.name}
                    </MenuItem>
                  );
                })
              ) : state.current.user ? (
                <MenuItem
                  value={state.current.user.id}
                >{`${state.current.user.lastname} ${state.current.user.firstname}`}</MenuItem>
              ) : (
                ""
              )}
            </Select>
          </Box>
        </FormControl>
      </FormGroup>

      <ListItem>
        <Box marginBottom="1.5rem">
          <FormGroup>
            <Grid>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={(e) => props.handleClickResetfunc()}
              >
                {t("button_clear")}
              </Button>
            </Grid>
          </FormGroup>
        </Box>
      </ListItem>
    </>
  );
};

export default IssueFilter;
